// components/sections/AgingSummarySection.tsx

import { formatCurrency } from "../../../../../utils/formatCurrency";

interface Props {
  data: {
    totalCustomers: number;
    totalPortfolio: number;
    highRiskAmount: number;
  };
}

const AgingSummarySection = ({
  data,
}: Props) => {
  const {
    totalCustomers,
    totalPortfolio,
    highRiskAmount,
  } = data;

  return (
    <section className="bg-white p-6 dark:bg-boxdark">
      {/* Header */}
      <div className="mb-5">
        <h4 className="text-base font-semibold text-black dark:text-white">
          Reporte Aging
        </h4>

        <p className="text-sm text-body dark:text-bodydark">
          Resumen general de antigüedad de deuda por cliente
        </p>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {/* Clientes con deuda */}
        <div
          className="
            rounded-xl
            border border-warning/20
            bg-warning/5
            p-5
          "
        >
          <p className="mb-2 text-xs font-medium uppercase tracking-wide text-body">
            Clientes con deuda
          </p>

          <p className="text-2xl font-bold text-warning">
            {totalCustomers || 0}
          </p>
        </div>

        {/* Total cartera */}
        <div
          className="
            rounded-xl
            border border-primary/20
            bg-primary/5
            p-5
          "
        >
          <p className="mb-2 text-xs font-medium uppercase tracking-wide text-body">
            Total cartera
          </p>

          <p className="text-2xl font-bold text-primary">
            ${formatCurrency(totalPortfolio)}
          </p>
        </div>

        {/* Riesgo alto */}
        <div
          className="
            rounded-xl
            border border-danger/20
            bg-danger/5
            p-5
          "
        >
          <p className="mb-2 text-xs font-medium uppercase tracking-wide text-body">
            Riesgo alto (+90 días)
          </p>

          <p className="text-2xl font-bold text-danger">
            ${formatCurrency(highRiskAmount)}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AgingSummarySection;